//記事一覧ページ
import React, { useState } from "react"
import { Link } from "gatsby"
import { GatsbyImage } from "gatsby-plugin-image";

import { kebabCase } from 'lodash/string';

import { StaticImage } from "gatsby-plugin-image"

//ads
import Ads from './GoogleAdSense'

//画面サイズ取得用
// import useMediaQuery from '@mui/material/useMediaQuery';

//material-
import { useTheme } from '@mui/material/styles';
import {
    Grid, Typography, LinearProgress, Chip,
    Tooltip, IconButton, Paper, Link as Link2,
    //カード用
    Card, CardActionArea, CardContent, CardMedia, CardActions, Box, Divider,
    //メニュー
    Menu, MenuItem,

} from '@mui/material';
import { styled } from '@mui/material/styles';
//アイコン ※名前が違うので１コずつインポート必須
// import CategoryOutlinedIcon from '@mui/icons-material/CategoryOutlined'
import DoubleArrow from '@mui/icons-material/DoubleArrow';
// import MoreVertIcon from '@mui/icons-material/MoreVert';
import LocalOfferOutlinedIcon from '@mui/icons-material/LocalOfferOutlined';

//react用
import InfiniteScroll from 'react-infinite-scroll-component'
// import { InfoOutlined } from "@mui/icons-material";



const BlogRoll = (({ posts, location, isIndexPage = false }) => {

    //広告を挿入するタイミング
    const adsTiming = 6

    const theme = useTheme()

    const styleCardGridItem = {
        width: "100%",
        alignItems: "stretch",
        [theme.breakpoints.down('sm')]: {
            padding: "0px !important",
            marginTop: theme.spacing(2)
        },
    }

    const styleCardRoot = {
        height: "100% !important",
        display: "flex",
        flexDirection: "column",
        //ここにminWidthをつけると表示崩れ
        maxWidth: "600px",
        alignItems: "stretch",
        //adsのコードが自動で上のタグのsizeを調整してしまうらしいので縦が崩れる。未解決

        //モバイル用だった場合カードの縁を消す
        [theme.breakpoints.down('sm')]: {
            borderLeft: "0px",
            borderRight: "0px",
            borderRadius: "0px"
        },
    }

    const StyledChip = styled(Chip)({
        //メモ &&のあとにスペースがあると正しく動かない？
        "&&: hover": {
            backgroundColor: theme.palette.primary.main
        },
        "&&: focus": {
            backgroundColor: theme.palette.primary.main
        }
    })

    //グリッドの親
    const styleGridParent = {
        margin: 0,
        width: '100%',
        //gridに謎のpaddingLeftが入る対策
        [theme.breakpoints.down('sm')]: { paddingRight: "0px" },
        [theme.breakpoints.up('sm')]: { paddingRight: theme.spacing(2) },
    }

    //難しい：domが更新されるたびに処理が走るシステム
    //googleAdsenseが強制的にheightを変えてしまうので更に強制的にheightを戻すシステム
    React.useEffect(() => {
        //リサイズオブザーバーは監視対象の要素のサイズが変化したときに発動する
        const resizeObserver = new ResizeObserver(entries => {
            const target = document.querySelectorAll('#ad_target')
            // const articleGrid = document.querySelectorAll("#article_grid")[0].clientHeight
            target.forEach((el, index) => {
                // el.style.height = articleGrid + "px"
                el.style.height = ""
            })
        });
        if (document.querySelector('#ad_target') != null) {
            resizeObserver.observe(document.querySelector('#ad_target'))
        }
    })

    const path = location ? location.pathname : "error: no path"

    //カード一枚分のデザイン
    const oneCard = ((post, index) => {

        //gatsbyPathを使ったパス取得
        //slugで行うとgatsby側の日本語や大文字の自動調整でリンク切れとなる
        //indexのgatsbyPathのgraphQueryを参考
        const postPath = post.postPath

        //画像が設定されていないポストがエラーになるので対処(プライバシーポリシーなど)
        const postImg = post.frontmatter.featuredimage ? post.frontmatter.featuredimage.childImageSharp.gatsbyImageData : null
        const postDate = post.frontmatter.date
        // const postDescription = post.frontmatter.description
        const postTitle = post.frontmatter.title
        const postTagsAll = post.frontmatter.tags
        // const postTags = post.frontmatter.tags?.slice(0, tagTrimTiming)
        // const postTagsMore = post.frontmatter.tags?.slice(tagTrimTiming)

        const parent_category = post.fields.parent_category
        const parent_category_id = post.fields.parent_category_id
        const child_category = post.fields.child_category
        const child_category_id = post.frontmatter.category_id

        return (
            <Card sx={styleCardRoot} variant="outlined" >
                <CardActionArea
                    component={Link} to={postPath}
                >
                    {postImg &&
                        <CardMedia >
                            <GatsbyImage image={postImg} alt="Article Thumbnail" />
                        </CardMedia>
                    }
                    <CardContent>
                        <Typography
                            sx={{
                                display: "-webkit-box",
                                boxOrient: "vertical",
                                lineClamp: 2,
                                wordBreak: "break-all",
                                overflow: "hidden",
                            }}
                            gutterBottom variant="subtitle1" component="h2"
                        >
                            {postTitle}
                        </Typography>
                        <Typography gutterBottom variant="caption" color="textSecondary" component="p">
                            {postDate}
                        </Typography>
                    </CardContent>
                </CardActionArea>
                {/* ボックスは下寄せのため */}
                <Box sx={{
                    alignItems: "flex-end",
                    justifyContent: "flex-end",
                    display: "flex",
                    height: "100%",
                }}>
                    <CardActions>
                        {/* カテゴリ */}
                        <Box sx={{
                            [theme.breakpoints.down('xl')]: { display: "none" }
                        }}>
                            <StyledChip
                                variant="outlined"
                                size="small"
                                disabled={!parent_category}
                                label={parent_category || "?"}
                                clickable
                                component={Link} to={"/category/" + kebabCase(parent_category_id)}
                            />
                            <DoubleArrow fontSize="small" sx={{ verticalAlign: "middle" }} />
                            <StyledChip
                                variant="outlined"
                                size="small"
                                disabled={!child_category}
                                label={child_category || "?"}
                                clickable
                                component={Link} to={"/category/" + kebabCase(child_category_id)}
                            />
                        </Box>
                        
                        <Tooltip title="この記事のタグ一覧">
                            <IconButton color="inherit" aria-label="tag-menu"
                                onClick={(event) => additionalTagsDialogOpen({ event, postTagsAll, postTitle })}
                                aria-controls={tagOpen ? 'tag-menu' : undefined}
                                aria-haspopup="true"
                                aria-expanded={tagOpen ? 'true' : undefined}
                            >
                                <LocalOfferOutlinedIcon color="primary" />
                            </IconButton>
                        </Tooltip>

                    </CardActions>
                </Box>
            </Card >
        );
    })

    //省略されているタグボタンをクリックした時のダイアログ用
    const [dialogTags, setDialogTags] = React.useState([])
    const additionalTagsDialogOpen = ({ event, postTagsAll, postTitle }) => {
        setAnchorEl(event.currentTarget)
        setDialogTags(postTagsAll)
    }
    const additionalTagsDialogClose = () => {
        setAnchorEl(null);
    }

    //タグ表示ボタンの処理
    const [anchorEl, setAnchorEl] = React.useState(false);
    const tagOpen = Boolean(anchorEl);

    const additionalTagDialog = () => {
        return (
            <Menu
                id="tag-menu"
                aria-labelledby="tag-menu"
                anchorEl={anchorEl}
                open={tagOpen}
                onClose={additionalTagsDialogClose}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
                //タグCSSホバーの色変更
                sx={{
                    '& .MuiMenuItem-root:hover': {
                        backgroundColor: theme.palette.divider
                    },
                }}
            >
                <Box sx={{ padding: theme.spacing(1) }}>


                    <Typography variant="caption" display="block" sx={{
                        display: 'flex',
                        alignItems: 'center',
                        flexWrap: 'wrap',
                    }}>
                        <LocalOfferOutlinedIcon fontSize="small" color="primary" />
                        <Box sx={{ marginLeft: theme.spacing(2) }}>タグ</Box>
                    </Typography>
                </Box>

                <Divider />

                {dialogTags.map((tag, index) => (
                    <MenuItem onClick={additionalTagsDialogClose}
                        key={"dialog_" + index + tag}
                        component={Link} to={"/tag/" + kebabCase(tag)}
                    >{tag}</MenuItem>
                ))}
            </Menu>
        )
    }
    //省略されているタグボタンをクリックした時のダイアログ用 ここまで

    const adCard = () => {
        return (
            <Card id="ad_target" sx={styleCardRoot} variant="outlined">
                {/* cardActionAreaを入れるとadsのwidthがとれずエラーになるので注意 */}
                <CardContent >
                    <Box sx={{ minHeight: "300px", minWidth: "250px", width: "100%", textAlign: "center", }} >
                        {/* //adsのコードが自動で上のタグのsizeを調整してしまうらしいので縦が崩れる。未解決 */}
                        <Ads
                            // clientは１コなのでslotだけ設定すればよい
                            path={path}
                            slot={process.env.GOOGLE_AD_SLOT2}
                            format={"horizontal,rectangle"}
                        />
                        {process.env.NODE_ENV === "development" &&
                            <StaticImage src="../images/logo.png" placeholder="blurred" alt="謎の技術研究部" />
                        }
                    </Box>
                </CardContent>
                <Divider />
                <Box sx={{
                    alignItems: "flex-end",
                    justifyContent: "flex-end",
                    display: "flex",
                    height: "100%",
                }}>
                    <CardActions >
                        <Chip
                            variant="outlined"
                            size="small"
                            label="スポンサーリンク"
                            disabled={true}
                        />
                    </CardActions>
                </Box>
            </Card >
        )
    }

    //記事一覧
    const articles = (
        <>
            <Grid container
                spacing={2}
                alignItems="stretch"
                sx={styleGridParent}>
                {posts.map((post, index) => {
                    if (
                        // index !== 0 && 一番頭の広告だけ表示しない時の条件
                        index % adsTiming === 0) {
                        //ad挿入時
                        return (
                            <React.Fragment key={index}>
                                <Grid id="ad_target" item sm={6} md={4} lg={3} sx={styleCardGridItem}>
                                    {adCard()}
                                </Grid>
                                <Grid id="article_grid" item sm={6} md={4} lg={3} sx={styleCardGridItem}>
                                    {oneCard(post)}
                                </Grid>
                            </React.Fragment>
                        )
                    } else {
                        //ad挿入ではない時
                        return (
                            <Grid item sm={6} md={4} lg={3} key={index} sx={styleCardGridItem}>
                                {oneCard(post)}
                            </Grid>
                        )
                    }
                })}
            </Grid>
            {additionalTagDialog()}
        </>
    )

    //無限スクロール用
    const [pageIndex, setPageIndex] = React.useState(0)
    const [showPosts, setShowPosts] = React.useState(posts)
    const [hasMore, setHasMore] = useState(true)

    //無限スクロール用
    const addPosts = (newPosts) => {
        const postsCopy = JSON.parse(JSON.stringify(showPosts))
        postsCopy.push(...newPosts)
        setShowPosts(postsCopy)
    }
    //無限スクロール用
    const fetchPosts = (nextPage) => {
        fetch(`/indexScroll-${nextPage}.json`)
            .then(response => response.json())
            .then(json => addPosts(json.items))
            .then(() => setPageIndex(nextPage))
            .catch(e => {
                // 取得しようとしたjsonファイルが存在しなかった → もう追加データがない
                setHasMore(false)
                // console.log(e)
            })
    }

    //無限スクロール用
    const articlesInfinite = (
        <InfiniteScroll
            dataLength={showPosts.length}
            // next={() => setPageIndex(pageIndex + 24)}
            next={() => fetchPosts(pageIndex + 1)}
            // hasMore={showPosts.length > pageIndex}
            hasMore={hasMore}
            scrollThreshold={0.9}
            loader={<LinearProgress />}
        >
            <Grid container
                spacing={2}
                alignItems="stretch"
                sx={styleGridParent}>

                {showPosts.map((post, index) => {
                    if (
                        // index !== 0 && 一番頭の広告だけ表示しない時の条件
                        index % adsTiming === 0) {
                        //ad挿入時
                        return (
                            <React.Fragment key={index}>
                                <Grid id="ad_target" item sm={6} md={4} lg={3} sx={styleCardGridItem} >

                                    {adCard()}

                                </Grid>
                                <Grid id="article_grid" item sm={6} md={4} lg={3} sx={styleCardGridItem}>
                                    {oneCard(post)}
                                </Grid>
                            </React.Fragment>
                        )
                    } else {
                        //ad挿入ではない時
                        return (
                            <Grid item sm={6} md={4} lg={3} key={index} sx={styleCardGridItem}>
                                {oneCard(post)}
                            </Grid>
                        )
                    }
                })}
            </Grid>

            < Paper sx={{
                marginLeft: theme.spacing(2),
                marginTop: theme.spacing(1),
                marginBottom: theme.spacing(2),
                padding: theme.spacing(1),
                paddingLeft: theme.spacing(2),
            }} variant="outlined">
                <Typography>
                    自動スクロールしない場合は
                    <Link2 color="inherit" component={Link} to="/sub_index/1">
                        サブインデックス
                    </Link2>
                    をご利用ください。
                </Typography>
            </Paper>

            {additionalTagDialog()}

        </InfiniteScroll >

    )

    if (isIndexPage) {
        return articlesInfinite
    } else {
        return articles
    }
})

export default BlogRoll